export default __webpack_public_path__ + "static/media/26.ab14324c.png";